export const errorCodeTypes = {
  invalidDaysAheadError: {
    code: 'SCH01',
    name: 'InvalidDaysAheadError',
    message:
      'The lead time (days in advance) cannot exceed the recurrence interval to prevent overlapping tasks.',
  },
};
